// Pricing toggle functionality
const pricingToggle = document.getElementById('price-plan-toggle');
const pricingToggleShadow = document.getElementById('price-plan-toggle-shadow');
const toggleStarter = document.getElementById('toggle-starter');
const toggleGrowth = document.getElementById('toggle-growth');
const togglePro = document.getElementById('toggle-pro');

// Get pricing card elements
const priceElement = document.getElementById('price');
const valuePropElement = document.getElementById('pricing-value-prop');
const magicBoostWrapper = document.getElementById('magic-boost-wrarpper');
const pricingValueTexts = document.querySelectorAll('.pricing-value-text');
const pricingContentElements = document.querySelectorAll('#pricing-value-prop, .pricing-value-text, .pricing-checkmark, #dividing-line');
const subscribeButton = document.getElementById('subscribe-button');

// Pricing content data
const pricingData = {
    starter: {
        price: '$995',
        valueProp: 'Design and marketing support to start or grow your business.',
        valueProps: [
            'Unlimited requests',
            '1-2 day turnaround',
            'Marketing support',
            'Lite strategy service',
            'Lite design service',
            'Pause/cancel anytime'
        ],
        showMagicBoost: true,
        stripeLink: 'https://buy.stripe.com/5kQ14mgGP8PacCv0hcbjW07'
    },
    growth: {
        price: '$2495',
        valueProp: 'Everything in Starter, plus faster design and development.',
        valueProps: [
            'Unlimited requests',
            '1-2 day turnaround',
            'Marketing support',
            'Full strategy service',
            'Design + lite development',
            'Pause/cancel anytime'
        ],
        showMagicBoost: false,
        stripeLink: 'https://buy.stripe.com/5kQ3cu3U32qM6e7aVQbjW08'
    },
    pro: {
        price: '$4995',
        valueProp: 'Full product strategy, design, and development, done right.',
        valueProps: [
            'Unlimited requests',
            '1-2 day turnaround',
            'Advanced strategy',
            'Full design service',
            'Custom development',
            'Pause/cancel anytime'
        ],
        showMagicBoost: false,
        stripeLink: 'https://buy.stripe.com/8x2cN462b8PagSL5BwbjW09'
    }
};

// Track current plan to determine if Magic Boost visibility is changing
let currentPlan = 'starter';
let currentPrice = '$995'; // Track the current price for ticker animation

// Function to initiate pricing content fade transition
function updatePricingContent(plan) {
    // Don't do anything if we're already on this plan
    if (currentPlan === plan) return;

    const currentData = pricingData[currentPlan];
    const newData = pricingData[plan];

    // Check if Magic Boost visibility is actually changing
    const magicBoostVisibilityChanging = currentData.showMagicBoost !== newData.showMagicBoost;

    // Update current plan tracker BEFORE animations start
    currentPlan = plan;

    // Handle Magic Boost visibility IMMEDIATELY (no delay)
    if (magicBoostVisibilityChanging) {
        if (newData.showMagicBoost) {
            // Showing Magic Boost: Remove hidden class to trigger expand animation
            magicBoostWrapper.classList.remove('hidden');
            // Force reflow to ensure animation starts immediately
            void magicBoostWrapper.offsetHeight;
        } else {
            // Hiding Magic Boost: Add hidden class to trigger collapse animation
            magicBoostWrapper.classList.add('hidden');
            // Force reflow to ensure animation starts immediately
            void magicBoostWrapper.offsetHeight;
        }
    }

    // Fade out pricing content
    pricingContentElements.forEach((element) => {
        element.classList.add('fade-pricing-out');
        element.classList.remove('fade-pricing-in');
    });

    // Wait 250ms, then update content and fade in
    setTimeout(function() {
        applyPricingContentChanges(plan);
    }, 250);
}

// Function to animate number ticker effect
function animateNumberTicker(element, startPrice, targetPrice) {
    // Remove $ and any commas, just get the numbers
    const targetNumber = parseInt(targetPrice.replace(/[$,]/g, ''));
    const startNumber = parseInt(startPrice.replace(/[$,]/g, ''));

    // Create wrapper for individual digits
    element.style.display = 'flex';
    element.style.overflow = 'hidden';
    element.innerHTML = '';

    // Create SVG filter for vertical motion blur (only if it doesn't exist)
    if (!document.getElementById('vertical-motion-blur')) {
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.style.position = 'absolute';
        svg.style.width = '0';
        svg.style.height = '0';

        const defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
        const filter = document.createElementNS('http://www.w3.org/2000/svg', 'filter');
        filter.setAttribute('id', 'vertical-motion-blur');

        const feGaussianBlur = document.createElementNS('http://www.w3.org/2000/svg', 'feGaussianBlur');
        feGaussianBlur.setAttribute('in', 'SourceGraphic');
        feGaussianBlur.setAttribute('stdDeviation', '0 3'); // 0 horizontal, 3 vertical

        filter.appendChild(feGaussianBlur);
        defs.appendChild(filter);
        svg.appendChild(defs);
        document.body.appendChild(svg);
    }

    // Add $ symbol
    const dollarSign = document.createElement('span');
    dollarSign.textContent = '$';
    element.appendChild(dollarSign);

    // Convert numbers to strings to get individual digits
    const targetDigits = targetNumber.toString().split('');
    const startDigits = startNumber.toString().split('');

    // Determine which number has more digits
    const targetLength = targetDigits.length;
    const startLength = startDigits.length;

    // If start has more digits than target, we need to handle digit disappearing
    // If target has more digits, pad start with zeros
    if (targetLength > startLength) {
        // Pad start with zeros on the left
        while (startDigits.length < targetLength) {
            startDigits.unshift('0');
        }
    } else if (startLength > targetLength) {
        // Don't pad target - just ignore extra start digits
        // We'll only animate the digits that exist in the target
    }

    // Create digit containers - use target length as the definitive length
    targetDigits.forEach((targetDigit, index) => {
        const digitContainer = document.createElement('span');
        digitContainer.style.position = 'relative';
        digitContainer.style.display = 'inline-block';
        digitContainer.style.height = '1em';
        digitContainer.style.width = '0.7em'; // Fixed width for consistent spacing
        digitContainer.style.overflow = 'hidden';
        digitContainer.style.textAlign = 'center'; // Center the digit within its fixed width

        const digitRoller = document.createElement('span');
        digitRoller.style.display = 'block';
        digitRoller.style.transition = 'transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1), filter 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)';

        // Get the corresponding start digit (might be 0 if padded)
        const startDigit = parseInt(startDigits[index]) || 0;
        const endDigit = parseInt(targetDigit);

        // Determine if we're going up or down overall by comparing full numbers
        const goingUp = targetNumber > startNumber;

        // Create sequence of numbers to roll through
        let sequence = [];

        if (endDigit === startDigit) {
            // No change for this digit
            sequence.push(endDigit);
        } else if (goingUp) {
            // Going up: roll upward
            if (endDigit > startDigit) {
                // Simple upward count: 4 -> 5 -> 6 -> 7
                for (let i = startDigit; i <= endDigit; i++) {
                    sequence.push(i);
                }
            } else {
                // Wrap around going up: 9 -> 0 wraps through top
                for (let i = startDigit; i <= 9; i++) {
                    sequence.push(i);
                }
                for (let i = 0; i <= endDigit; i++) {
                    sequence.push(i);
                }
            }
        } else {
            // Going down: roll downward
            if (endDigit < startDigit) {
                // Build upward sequence but we'll reverse it: 4 -> 5 -> 6 -> 7 -> 8 -> 9
                // This way the visual scroll direction will be downward
                for (let i = endDigit; i <= startDigit; i++) {
                    sequence.push(i);
                }
            } else {
                // Wrap around going down: build the sequence we'll reverse
                for (let i = endDigit; i <= 9; i++) {
                    sequence.push(i);
                }
                for (let i = 0; i <= startDigit; i++) {
                    sequence.push(i);
                }
            }
        }

        // Populate roller with sequence
        sequence.forEach((num) => {
            const numSpan = document.createElement('span');
            numSpan.style.display = 'block';
            numSpan.textContent = num;
            digitRoller.appendChild(numSpan);
        });

        digitContainer.appendChild(digitRoller);
        element.appendChild(digitContainer);

        // For downward animations, sequence is reversed so start at bottom and animate up
        // For upward animations, start at top and animate down
        if (!goingUp && endDigit !== startDigit) {
            // Going down: sequence is [4,5,6,7,8,9], start at bottom (showing 9)
            const startOffset = -(sequence.length - 1);
            digitRoller.style.transform = `translateY(${startOffset}em)`;
            digitRoller.style.filter = 'none';

            // Force a reflow
            void digitRoller.offsetHeight;

            // Animate to top (showing 4) with vertical blur
            setTimeout(() => {
                digitRoller.style.transform = 'translateY(0)';
                digitRoller.style.filter = 'url(#vertical-motion-blur)';

                // Remove blur at the end of animation
                setTimeout(() => {
                    digitRoller.style.filter = 'none';
                }, 250);
            }, 10 + (index * 50));
        } else if (endDigit === startDigit) {
            // No change: just display the digit without any animation or blur
            digitRoller.style.transform = 'translateY(0)';
            digitRoller.style.filter = 'none';
        } else {
            // Going up: sequence is [4,5,6,7,8,9], start at top (showing 4)
            digitRoller.style.transform = 'translateY(0)';
            digitRoller.style.filter = 'none';

            // Force a reflow
            void digitRoller.offsetHeight;

            // Animate to bottom (showing 9) with vertical blur
            setTimeout(() => {
                const offset = -(sequence.length - 1);
                digitRoller.style.transform = `translateY(${offset}em)`;
                digitRoller.style.filter = 'url(#vertical-motion-blur)';

                // Remove blur at the end of animation
                setTimeout(() => {
                    digitRoller.style.filter = 'none';
                }, 250);
            }, 10 + (index * 50));
        }
    });
}

// Function to apply content changes and fade in
function applyPricingContentChanges(plan) {
    const data = pricingData[plan];

    // Animate price with ticker effect (from current price to new price)
    animateNumberTicker(priceElement, currentPrice, data.price);

    // Update the tracked current price
    currentPrice = data.price;

    // Update value proposition
    valuePropElement.textContent = data.valueProp;

    // Update value prop items
    pricingValueTexts.forEach((element, index) => {
        if (data.valueProps[index]) {
            element.textContent = data.valueProps[index];
        }
    });

    // Fade in pricing content
    pricingContentElements.forEach((element) => {
        element.classList.add('fade-pricing-in');
        element.classList.remove('fade-pricing-out');
    });
}

// Function to switch to Starter plan
function switchToStarter() {
    pricingToggle.classList.remove('active-growth', 'active-pro');
    pricingToggleShadow.classList.remove('active-growth', 'active-pro');
    toggleStarter.classList.add('active');
    toggleGrowth.classList.remove('active');
    togglePro.classList.remove('active');

    updatePricingContent('starter');
}

// Function to switch to Growth plan
function switchToGrowth() {
    pricingToggle.classList.remove('active-pro');
    pricingToggle.classList.add('active-growth');
    pricingToggleShadow.classList.remove('active-pro');
    pricingToggleShadow.classList.add('active-growth');
    toggleStarter.classList.remove('active');
    toggleGrowth.classList.add('active');
    togglePro.classList.remove('active');

    updatePricingContent('growth');
}

// Function to switch to Pro plan
function switchToPro() {
    pricingToggle.classList.remove('active-growth');
    pricingToggle.classList.add('active-pro');
    pricingToggleShadow.classList.remove('active-growth');
    pricingToggleShadow.classList.add('active-pro');
    toggleStarter.classList.remove('active');
    toggleGrowth.classList.remove('active');
    togglePro.classList.add('active');

    updatePricingContent('pro');
}

// Event listeners for clicking on labels
toggleStarter.addEventListener('click', switchToStarter);
toggleGrowth.addEventListener('click', switchToGrowth);
togglePro.addEventListener('click', switchToPro);

// Subscribe button click handler
subscribeButton.addEventListener('click', function() {
    const stripeLink = pricingData[currentPlan].stripeLink;
    window.location.href = stripeLink;
});
